<template>
	<div class="p-grid p-fluid p-justify-center">
		<div class="p-col-12 p-md-8 p-lg-6 p-xl-4">
			<div class="card card-w-title">
				<h1>{{$t('reset password')}}</h1>
				<div class="p-grid">
					<template v-if="passwordUpdated">
						<div class="p-col-12">
							<div class="p-messages p-component p-messages-success" style="margin: 0 0 1em 0; display: block">
								<div class="p-messages-wrapper">
									<span class="p-messages-icon pi pi-fw pi-2x pi-check"></span>
									<span class="p-messages-detail">{{$t('resetPwdMessage')}}
									</span>
								</div>
							</div>
						</div>
						<div class="p-col-4">
							<router-link to="/login">
								<Button :label="$t('login')" />
							</router-link>
						</div>
					</template>
					<template v-else>
						<div class="p-col-12">
							<label htmlFor="acSimple">{{$t('email')}}</label>
						</div>
						<div class="p-col-12">
							<InputText v-model="email" :class="{ 'p-error': resetClicked && !email }" />
						</div>
						<div class="p-col-12">
							<label htmlFor="acAdvanced">{{$t('password')}}</label>
						</div>
						<div class="p-col-12">
							<Password v-model="password" :feedback="true" :class="{ 'p-error': resetClicked && !password }" />
						</div>
						<div class="p-col-5 p-md-3">
							<Button :label="$t('confirm')" @click="reset" />
						</div>
						<div class="p-col">
							<div class="p-col">
								<router-link to="/login">{{$t('cancel')}}</router-link>
							</div>
						</div>
						<div class="p-col-4 p-md-3">
							<LanguageSelector />
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AuthService from "@/service/AuthService";

export default {
	data() {
		return {
			email: "",
			password: "",
			resetClicked: false,
			passwordUpdated: false,
		};
	},
	beforeCreate: function () {
		document.body.className = "login";
	},
	authService: null,
	created() {
		this.AuthService = new AuthService();
	},
	methods: {
		reset() {
			this.resetClicked = true;
			if (this.email && this.password) {
				this.AuthService.resetPassword(
					this.$route.query.code,
					this.email,
					this.password
				)
					.then((res) => {
						this.passwordUpdated = true;
						return res;
					})
					.catch((error) => {
						self.$router.push("/login");
						return error;
					});
			}
		},
	},
};
</script>